/**
 * Site cookie banners run inside sandboxed previews. Those frames cannot read
 * document.cookie or CookieStore, and the banner scripts throw when they try.
 * This stub keeps the jar empty so the scripts continue without the admin cookies.
 */
export const SANDBOX_COOKIE_SHIM = `(function(){
  var jar = "";
  var cookie = {
    configurable: true,
    get: function () { return jar; },
    set: function (value) { jar = String(value == null ? "" : value); }
  };
  try {
    Object.defineProperty(Document.prototype, "cookie", cookie);
  } catch (error) {
    try { Object.defineProperty(document, "cookie", cookie); } catch (ignored) {}
  }
  var done = function (value) { return Promise.resolve(value); };
  var store = {
    get: function () { return done(null); },
    getAll: function () { return done([]); },
    set: function () { return done(undefined); },
    delete: function () { return done(undefined); },
    addEventListener: function () {},
    removeEventListener: function () {}
  };
  try {
    Object.defineProperty(window, "cookieStore", { configurable: true, writable: true, value: store });
  } catch (error) {
    try { window.cookieStore = store; } catch (ignored) {}
  }
})();`;

const SHIM_MARK = "data-sbcms-sandbox-cookies";

/** Put the cookie stub before any site script in a preview or editor document. */
export const withSandboxCookieShim = (html: string): string => {
  if (!html.trim() || html.includes(SHIM_MARK)) {
    return html;
  }

  const script = `<script ${SHIM_MARK}>${SANDBOX_COOKIE_SHIM}</script>`;

  if (/<head[^>]*>/i.test(html)) {
    return html.replace(/<head[^>]*>/i, (head) => `${head}${script}`);
  }

  if (/<html[^>]*>/i.test(html)) {
    return html.replace(/<html[^>]*>/i, (tag) => `${tag}<head>${script}</head>`);
  }

  return `<!DOCTYPE html><html><head>${script}</head><body>${html}</body></html>`;
};
